import Arrow from '../images/arrow.svg';

export default function Button(props) {
    return (
        <button onClick={props.onClick} className="button" style = {{backgroundColor: 'rgba(255, 255, 255, 0.08)', border: '1px solid rgba(255, 255, 255, 0.2)', color: 'white', padding: '10px 20px', fontSize: '24px', cursor: 'pointer', fontFamily: 'Abel'}}>
            {props.text}
            <img src = {Arrow} className = "button-arrow" alt = "arrow" style = {{width: '15px', height: '11px', marginLeft: '10px', marginBottom: '2px', marginRight: '-2px', transitionDuration: '.4s'}}/>
        </button>
    )

}